// Adaptive input gain for the realtime mic path.
//
// Measured 2026-09-14: this capture path can deliver normal speech ~40 dB below full
// scale (peaks of 100-400 out of 32767). OpenAI's VAD tolerates that and transcribes
// fine; xAI's server_vad ignores it outright — no speech_started, no reply — and
// lowering xAI's threshold does NOT help (verified against the real captured audio).
// The same audio amplified triggers xAI reliably, so the deficiency is level, not
// configuration, and it belongs here rather than in one provider's consumer.
//
// Boost-only by design: a healthy mic is left untouched (gain never goes below 1), and
// the gain does not ramp up during silence — that would just amplify the noise floor
// until VAD fires on nothing.

export const TARGET_PEAK = 0.28;   // ~9200/32767; comfortably clears xAI's VAD
export const MAX_GAIN = 30;        // caps how hard a very quiet mic is pushed
export const NOISE_FLOOR = 0.002;  // below this a frame is room noise, not speech
export const DECAY = 0.95;         // envelope release per frame
export const SMOOTHING = 0.2;      // gain slew per frame, avoids audible pumping

/** Envelope-following gain. Pure: takes and returns the whole AGC state. */
export function nextGain(framePeak, envelope, gain) {
  const env = Math.max(framePeak, envelope * DECAY);
  let target = gain;
  if (env > NOISE_FLOOR) {
    target = Math.min(MAX_GAIN, Math.max(1, TARGET_PEAK / env));
  }
  return { envelope: env, gain: gain + (target - gain) * SMOOTHING };
}

/** Peak absolute sample of a Float32 frame. */
export function framePeakOf(samples) {
  let peak = 0;
  for (let i = 0; i < samples.length; i++) {
    const v = samples[i] < 0 ? -samples[i] : samples[i];
    if (v > peak) peak = v;
  }
  return peak;
}
